import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { ProductsServices } from "../../../services";
import { FormBuilder, Validators } from '@angular/forms';
import { ProvidersServices } from "../../../../providers/services";
import { StaticsServices } from "../../../../services/statics";
import { TranslateService } from '@ngx-translate/core';
import { ProductCreateWfoodcostAllergensPage } from '../product-create-wfoodcost-allergens/product-create-wfoodcost-allergens';
import { AnalyticsServices } from '../../../../services/analyticsServices';
import { AIServices } from '../../../../services/aiServices';
import { AddonsTriggerVersionProPage } from '../../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the ProductCreateWfoodcostInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-product-create-wfoodcost-info',
  templateUrl: 'product-create-wfoodcost-info.html',
})
export class ProductCreateWfoodcostInfoPage {

  product_name: any;
  product_uid: string;
  update_state: boolean = false;
  es: any;
  en: any;
  it: any;
  de: any;
  fr: any;
  ca: any;
  des_es: any;
  des_en: any;
  des_it: any;
  des_de: any;
  des_fr: any;
  des_ca: any;
  product: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public productsServices: ProductsServices,
    public fb: FormBuilder,
    public globals: Globals,
    private toastCtrl: ToastController,
    public providersServices: ProvidersServices,
    public staticsServices: StaticsServices,
    public translateService: TranslateService,
    public aiServices: AIServices,
    public analyticsServices: AnalyticsServices,
    public alertCtrl: AlertController) {
    //Params
    this.update_state = this.navParams.get('update_state');
    this.product_name = this.navParams.get('product_name');
    this.product = this.navParams.get('product');

    //Si hacemos update adamptamos la informacion
    if (this.update_state) {

      this.productsServices.product_tags = this.navParams.get('tags');
      this.product_uid = this.navParams.get('product_uid');

      var stock_max = 0;
      if (this.navParams.get('stock_max')) {
        stock_max = this.navParams.get('stock_max')
      }

      this.productsServices.form = fb.group({
        name: [this.navParams.get('product_name')],
        name_en: [this.navParams.get('name_en')],
        name_fr: [this.navParams.get('name_fr')],
        name_it: [this.navParams.get('name_it')],
        name_de: [this.navParams.get('name_de')],
        name_ca: [this.navParams.get('name_ca')],
        measurement: [this.navParams.get('measurement')],
        stock: [this.navParams.get('stock')],
        stock_alert: [this.navParams.get('stock_alert')],
        stock_max: [stock_max],
        sub_recipe: [false],
        pvp: [this.navParams.get('pvp')],
        description_es: [this.navParams.get('description_es')],
        description_en: [this.navParams.get('description_en')],
        description_fr: [this.navParams.get('description_fr')],
        description_it: [this.navParams.get('description_it')],
        description_de: [this.navParams.get('description_de')],
        description_ca: [this.navParams.get('description_ca')],
      });

    } else {
      this.productsServices.product_tags = Array();

      this.productsServices.form = fb.group({
        name: ['', this.returnRequiredByLang('es')],
        name_en: ['', this.returnRequiredByLang('en')],
        name_fr: ['', this.returnRequiredByLang('fr')],
        name_it: ['', this.returnRequiredByLang('it')],
        name_de: ['', this.returnRequiredByLang('de')],
        name_ca: ['', this.returnRequiredByLang('ca')],
        measurement: ['ud.'],
        stock: [0],
        stock_alert: [0],
        stock_max: [0],
        sub_recipe: [false],
        pvp: [0],
        description_es: [''],
        description_en: [''],
        description_fr: [''],
        description_it: [''],
        description_de: [''],
        description_ca: [''],
      });
    }


  }

  returnRequiredByLang(lang) {
    if (this.globals.restaurant.lang == lang) {
      return Validators.compose([Validators.required]);
    } else {
      return '';
    }
  }

  submit() {
    if (this.productsServices.form.valid) {
      // Validar que haya al menos un tag seleccionado
      if (!this.productsServices.product_tags || this.productsServices.product_tags.length === 0) {
        let toast = this.toastCtrl.create({
          message: this.translateService.instant('instant-introduce-categoria-plato-continuar'),
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
        return;
      }
      
      if (!this.update_state) {
        this.insert();
      } else {
        this.update();
      }
    } else {
      let toast = this.toastCtrl.create({
        message: this.translateService.instant('instant-introduce-nombre-producto-continuar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  updateDefaultNames() {
    // Detectar el idioma principal del restaurante
    let mainLang = this.globals.restaurant.lang;
    let mainField = mainLang === 'es' ? 'name' : `name_${mainLang}`;
    const mainName = this.productsServices.form.value[mainField];
    if (mainName) {
      const formValue = this.productsServices.form.value;
      if (!formValue.name) formValue.name = mainName;
      if (!formValue.name_en) formValue.name_en = mainName;
      if (!formValue.name_fr) formValue.name_fr = mainName;
      if (!formValue.name_it) formValue.name_it = mainName;
      if (!formValue.name_de) formValue.name_de = mainName;
      if (!formValue.name_ca) formValue.name_ca = mainName;
      this.productsServices.form.patchValue(formValue);
    }
  }

  insert() {
    this.updateDefaultNames();
    this.product = {
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'name': this.productsServices.form.value.name,
      'name_en': this.productsServices.form.value.name_en,
      'name_fr': this.productsServices.form.value.name_fr,
      'name_it': this.productsServices.form.value.name_it,
      'name_de': this.productsServices.form.value.name_de,
      'name_ca': this.productsServices.form.value.name_ca,
      'measurement': this.productsServices.form.value.measurement,
      'stock': 0,
      'stock_alert': 0,
      'stock_max': 0,
      'sub_recipe': false,
      'tags': this.productsServices.product_tags,
      'tags_static': this.productsServices.product_tags.toString(),
      'pvp': 0,
      'pvp2': 0,
      'pvp3': 0,
      'price_static': 0,
      'provider_static': this.translateService.instant('general-sin-proveedor'),
      'providers': [{
        default: true,
        name_static: this.translateService.instant('general-sin-proveedor'),
        price_static: 0,
        pricetotal_static: 0,
        tax_static: 4,
        uid: this.globals.no_provider.UID,
        updated_at: new Date()
      }],
      'created_at': new Date(),
      'updated_at': new Date(),
      'description_es': this.productsServices.form.value.description_es,
      'description_en': this.productsServices.form.value.description_en,
      'description_fr': this.productsServices.form.value.description_fr,
      'description_it': this.productsServices.form.value.description_it,
      'description_de': this.productsServices.form.value.description_de,
      'description_ca': this.productsServices.form.value.description_ca,
    };
    this.productsServices.afs.collection('products').add(this.product).then(doc => {
      // Añadir tags nuevos al array global
      if (this.product.tags && this.product.tags.length > 0) {
        this.globals.addTagsToGlobal(this.product.tags);
      }
      this.globals.GAtrackView('Products', 'Products - Name - Create', this.globals.restaurant.email, 'Create/Update', 'Create name', 'Products', this.productsServices.form.value.name);
      this.analyticsServices.trackingExpArticles('create product', this.globals.tracking_exp['create_article'], doc.id);
      //dataset
      this.sendData();
      this.finisher();
      //navCtrl
      this.productsServices.product_tags = null;
      this.navCtrl.push(ProductCreateWfoodcostAllergensPage, {
        update_state: false,
        product_uid: doc.id,
        product_name: this.globals.nameLangSelectProduct(this.productsServices.form.value),
        product_measurement: this.productsServices.form.value.measurement,
        product: this.product,
        article_uid: doc.id,
        article_type: 'product'
      });
    });
  }

  update() {
    this.productsServices.afs.collection('products').doc(this.product_uid).update({
      'name': this.productsServices.form.value.name,
      'name_en': this.productsServices.form.value.name_en,
      'name_fr': this.productsServices.form.value.name_fr,
      'name_it': this.productsServices.form.value.name_it,
      'name_de': this.productsServices.form.value.name_de,
      'name_ca': this.productsServices.form.value.name_ca,
      'measurement': this.productsServices.form.value.measurement,
      'stock': this.productsServices.form.value.stock,
      'stock_alert': this.productsServices.form.value.stock_alert,
      'stock_max': this.productsServices.form.value.stock_max,
      'tags': this.productsServices.product_tags,
      'tags_static': this.productsServices.product_tags.toString(),
      'sub_recipe': false,
      'pvp': this.productsServices.form.value.pvp,
      'description_es': this.productsServices.form.value.description_es,
      'description_en': this.productsServices.form.value.description_en,
      'description_fr': this.productsServices.form.value.description_fr,
      'description_it': this.productsServices.form.value.description_it,
      'description_de': this.productsServices.form.value.description_de,
      'description_ca': this.productsServices.form.value.description_ca,
      'updated_at': new Date(),
      'updated_user': this.globals.user_name
    }).then(() => {
      // Añadir tags nuevos al array global
      if (this.productsServices.product_tags && this.productsServices.product_tags.length > 0) {
        this.globals.addTagsToGlobal(this.productsServices.product_tags);
      }
      this.globals.GAtrackView('Products', 'Products - Name - Update', this.globals.restaurant.email, 'Create/Update', 'Update name', 'Products', this.productsServices.form.value.name);
      this.analyticsServices.trackingExpArticles('update product', this.globals.tracking_exp['update_article'], this.product_uid);
      //dataset
      this.sendData();
      this.staticsServices.changeStateStaticWait(true);
      this.navCtrl.pop();
    });
  }

  sendData() {
    var extra = {
      "min_stock": this.productsServices.form.value.stock_alert,
      "max_stock": this.productsServices.form.value.stock_max,
    };
    this.globals.dataSet('product_name', this.productsServices.form.value.name, '', JSON.stringify(extra));
    if (this.productsServices.form.value.pvp) {
      this.globals.dataSet('product_price', this.productsServices.form.value.pvp, '', this.product_name);
    }
    for (let value of this.productsServices.product_tags) {
      this.globals.dataSet('product_tag', value, '', this.productsServices.form.value.name);
    }
  }

  finisher() {
    if (this.globals.restaurant.plg_articles_finisher === undefined || this.globals.restaurant.plg_articles_finisher === false) {
      this.productsServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        plg_articles_finisher: true
      });
      this.globals.restaurant.plg_articles_finisher = true;
      this.analyticsServices.trackingExpArticles('finisher', this.globals.tracking_exp['finisher'], '');
    }
  }

  translate() {
    if (!this.globals.checkLimitsByLicense('dishes', 'langs')) {
      this.navCtrl.push(AddonsTriggerVersionProPage);
      return;
    }
    //preguntar
    let alert = this.alertCtrl.create({
      title: this.translateService.instant('instant-traducir-plato'),
      message: this.translateService.instant('instant-traducir-auto-plato-message'),
      buttons: [
        {
          text: this.translateService.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translateService.instant('general-si'),
          handler: () => {
            this.translateDish();
          }
        }
      ]
    });
    alert.present();
  }

  async translateDish() {
    // Mostrar loader
    const loader = this.loadingCtrl.create({
      content: this.translateService.instant('instant-traduciendo') || 'Traduciendo...',
      dismissOnPageChange: false
    });
    await loader.present();

    try {
      // Obtener el idioma del restaurante, nombre y descripción del producto
      const restaurantLang = this.globals.restaurant.lang;
      const productName = this.returnNameContent();
      const productDescription = this.returnDescriptionContent();

      // Definir prompts según el idioma del restaurante
      const prompts = {
        'es': {
          system: "Eres un experto traductor gastronómico. Debes traducir el nombre y descripción de un producto a 6 idiomas: español (es), inglés (en), francés (fr), alemán (de), italiano (it) y catalán (ca). Responde únicamente con un JSON válido que contenga las traducciones con las claves: names (para los nombres) y descriptions (para las descripciones), cada una con las claves: es, en, fr, de, it, ca. No añadas ningún texto adicional, solo el JSON.",
          user: `Traduce el nombre y descripción de este producto:\nNombre: "${productName}"\nDescripción: "${productDescription}"\n\na los 6 idiomas mencionados. Responde solo con el JSON.`
        },
        'en': {
          system: "You are an expert gastronomic translator. You must translate a product name and description to 6 languages: Spanish (es), English (en), French (fr), German (de), Italian (it) and Catalan (ca). Respond only with a valid JSON containing the translations with keys: names (for names) and descriptions (for descriptions), each with keys: es, en, fr, de, it, ca. Do not add any additional text, just the JSON.",
          user: `Translate the name and description of this product:\nName: "${productName}"\nDescription: "${productDescription}"\n\nto the 6 mentioned languages. Respond only with the JSON.`
        },
        'fr': {
          system: "Vous êtes un traducteur gastronomique expert. Vous devez traduire le nom et la description d'un produit en 6 langues : espagnol (es), anglais (en), français (fr), allemand (de), italien (it) et catalan (ca). Répondez uniquement avec un JSON valide contenant les traductions avec les clés : names (pour les noms) et descriptions (pour les descriptions), chacune avec les clés : es, en, fr, de, it, ca. N'ajoutez aucun texte supplémentaire, juste le JSON.",
          user: `Traduisez le nom et la description de ce produit :\nNom : "${productName}"\nDescription : "${productDescription}"\n\ndans les 6 langues mentionnées. Répondez uniquement avec le JSON.`
        },
        'de': {
          system: "Sie sind ein Experte für gastronomische Übersetzungen. Sie müssen den Namen und die Beschreibung eines Produkts in 6 Sprachen übersetzen: Spanisch (es), Englisch (en), Französisch (fr), Deutsch (de), Italienisch (it) und Katalanisch (ca). Antworten Sie nur mit einem gültigen JSON, das die Übersetzungen mit den Schlüsseln enthält: names (für Namen) und descriptions (für Beschreibungen), jede mit den Schlüsseln: es, en, fr, de, it, ca. Fügen Sie keinen zusätzlichen Text hinzu, nur das JSON.",
          user: `Übersetzen Sie den Namen und die Beschreibung dieses Produkts:\nName: "${productName}"\nBeschreibung: "${productDescription}"\n\nin die 6 genannten Sprachen. Antworten Sie nur mit dem JSON.`
        },
        'it': {
          system: "Sei un traduttore gastronomico esperto. Devi tradurre il nome e la descrizione di un prodotto in 6 lingue: spagnolo (es), inglese (en), francese (fr), tedesco (de), italiano (it) e catalano (ca). Rispondi solo con un JSON valido contenente le traduzioni con le chiavi: names (per i nomi) e descriptions (per le descrizioni), ciascuna con le chiavi: es, en, fr, de, it, ca. Non aggiungere alcun testo aggiuntivo, solo il JSON.",
          user: `Traduci il nome e la descrizione di questo prodotto:\nNome: "${productName}"\nDescrizione: "${productDescription}"\n\nnelle 6 lingue menzionate. Rispondi solo con il JSON.`
        },
        'ca': {
          system: "Ets un traductor gastronòmic expert. Has de traduir el nom i la descripció d'un producte a 6 idiomes: espanyol (es), anglès (en), francès (fr), alemany (de), italià (it) i català (ca). Respon únicament amb un JSON vàlid que contingui les traduccions amb les claus: names (per als noms) i descriptions (per a les descripcions), cadascuna amb les claus: es, en, fr, de, it, ca. No afegeixis cap text addicional, només el JSON.",
          user: `Traduïu el nom i la descripció d'aquest producte:\nNom: "${productName}"\nDescripció: "${productDescription}"\n\nals 6 idiomes esmentats. Respon només amb el JSON.`
        }
      };

      // Obtener el prompt correspondiente al idioma del restaurante
      const prompt = prompts[restaurantLang] || prompts['en']; // Fallback a inglés si no existe el idioma

      const messages = [
        {
          "role": "system",
          "content": prompt.system
        },
        {
          "role": "user",
          "content": prompt.user
        }
      ];

      // Configurar el formato de respuesta JSON
      const response_format = { "type": "json_object" };

      // Llamar a DeepSeek
      const response = await this.aiServices.deepseekOpenAIGenerateText(response_format, messages);

      // Procesar la respuesta
      if (response && response['choices'] && response['choices'][0] && response['choices'][0]['message']) {
        const content = response['choices'][0]['message']['content'];
        const translations = JSON.parse(content);

        // Actualizar el formulario de nombres
        if (translations.names) {
          this.productsServices.form.patchValue({
            name: translations.names['es'][0].toUpperCase() + translations.names['es'].substring(1) || '',
            name_en: translations.names['en'][0].toUpperCase() + translations.names['en'].substring(1) || '',
            name_fr: translations.names['fr'][0].toUpperCase() + translations.names['fr'].substring(1) || '',
            name_it: translations.names['it'][0].toUpperCase() + translations.names['it'].substring(1) || '',
            name_de: translations.names['de'][0].toUpperCase() + translations.names['de'].substring(1) || '',
            name_ca: translations.names['ca'][0].toUpperCase() + translations.names['ca'].substring(1) || ''
          });
        }

        // Actualizar el formulario de descripciones
        if (translations.descriptions) {
          this.productsServices.form.patchValue({
            description_es: translations.descriptions['es'] === 'null' ? '' : translations.descriptions['es'],
            description_en: translations.descriptions['en'] === 'null' ? '' : translations.descriptions['en'],
            description_fr: translations.descriptions['fr'] === 'null' ? '' : translations.descriptions['fr'],
            description_it: translations.descriptions['it'] === 'null' ? '' : translations.descriptions['it'],
            description_de: translations.descriptions['de'] === 'null' ? '' : translations.descriptions['de'],
            description_ca: translations.descriptions['ca'] === 'null' ? '' : translations.descriptions['ca']
          });
        }
      }

      // Ocultar loader al completar exitosamente
      loader.dismiss();

    } catch (error) {
      // Ocultar loader en caso de error
      loader.dismiss();

      console.error('Error al traducir con DeepSeek:', error);
      // Mostrar mensaje de error al usuario
      let alert = this.alertCtrl.create({
        title: this.translateService.instant('general-error'),
        message: this.translateService.instant('instant-traducir-error') || 'Error al traducir el producto',
        buttons: ['OK']
      });
      alert.present();
    }
  }

  returnNameContent() {
    switch (this.globals.restaurant.lang) {
      case 'es': {
        return this.productsServices.form.value.name;
      }
      case 'en': {
        return this.productsServices.form.value.name_en;
      }
      case 'fr': {
        return this.productsServices.form.value.name_fr;
      }
      case 'de': {
        return this.productsServices.form.value.name_de;
      }
      case 'it': {
        return this.productsServices.form.value.name_it;
      }
      case 'ca': {
        return this.productsServices.form.value.name_ca;
      }
    }
  }

  returnDescriptionContent() {
    switch (this.globals.restaurant.lang) {
      case 'es': {
        return this.productsServices.form.value.description_es;
      }
      case 'en': {
        return this.productsServices.form.value.description_en;
      }
      case 'fr': {
        return this.productsServices.form.value.description_fr;
      }
      case 'de': {
        return this.productsServices.form.value.description_de;
      }
      case 'it': {
        return this.productsServices.form.value.description_it;
      }
      case 'ca': {
        return this.productsServices.form.value.description_ca;
      }
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-info/product-create-wfoodcost-info.ts